import { transformPropOrder } from './basler-components.es783.js';

const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...transformPropOrder,
]);

export { positionalKeys };
